import CommonHeader from '../pages/Head'
import React from 'react'
import {Link} from "react-router-dom";
import axios from 'axios';
import ApplyImg from '../images/Apply Now_1.jpg'
import ExistCustomer from '../images/Existing_Customers.jpg'
import CanMoney from '../images/payday-payday-loans-ca-4.jpg'
import MicroSoft from '../images/windowslive_logo.png'
import Gmails from '../images/gmail_logo.gif'
import Yahoomail from '../images/yahoomail_logo.gif'
import RBCLogo from '../images/rbc_logo.png'
import CIBCLog from '../images/cibc_logo.png'
import TDLogo from '../images/td_logo.png'
import BMOLogo from '../images/bmo_logo.png'
import ScotiaLogo from '../images/scotiabank_logo.png'
import AdobeLogo from '../images/get_adobe_reader.png'
import HeadLogo from '../images/header_image.jpg'

class HomtContents extends React.Component {	  
	constructor(props) {
		super(props);
		this.state = {CompName:''};				
	}

	componentDidMount() {				
		axios.post(process.env.REACT_APP_API_ENV+'api/FindCompanyName.php')
			.then(result => {				
				this.setState({CompName:result.data[0]})													
			})		
	}
	render() {		
		return(
			<div>
				<CommonHeader titles="Payday Loan Tool"/>				
				<h1 className="headings" style={{textAlign:"center",color:"green"}}><small>{this.state.CompName}--Payday Loan Provider for Canadians</small></h1>				
				<div id="contentwrapper" >
					<div id="contentcolumn">
						<Link className="applybutton" to = "/Apply"><img border="0" src={ApplyImg} alt="Payday loans application"/></Link>
						<Link className="applybutton" to = "/Member"><img border="0" src={ExistCustomer} alt="Payday loans Returning Customers"/></Link>
					</div>
				</div>
				<div id="rightcolumn">
					<div className="innertext">
						<b style={{color:"green"}}>No Fax</b><br/>
						<b style={{color:"green"}}>Fast and Easy</b><br/>
						<b style={{color:"green"}}>No hidden cost</b><br/>
						<b style={{color:"green"}}>No Credit Check</b><br/>
						<b style={{color:"green"}}>Up to $600 until next pay day</b><br/>
						<b style={{color:"green"}}>Cash advance deposited directly to your account</b><br/>
					</div>
				</div>
				<div id="leftcolumn" title="Your payday loans"><img src={CanMoney} alt="Your Payday loans and cash advance"/></div>
				<div id="bottom"><br/>
					<h1 style={{color:"blue"}}>Free Email Services</h1>
					<h4>Sign up here for your free email service</h4>					
					<Link to = {{pathname:"https://signup.live.com/newuser.aspx?mkt=EN-CA&amp;rollrs=03&amp;lic=1"}} target="_blank"><img src={MicroSoft} width="174" height="35" alt="Windows Live" style={{backgroundColor:"white",border:0}}/></Link>&nbsp;&nbsp;&nbsp;&nbsp;
					<Link to = {{pathname:"https://www.google.com/accounts/NewAccount?service=mail&amp;continue=http%3A%2F%2Fmail.google.com%2Fmail%2Fe-11-10ded9b6e7caf20852bce801a278593e-8b4b0924a77a6a86a7506a1710f993392b58a8d3&amp;type=2"}} target="_blank"><img src={Gmails} width="143" height="59" alt="Google gmail" style={{backgroundColor:"white",border:0}}/></Link>&nbsp;&nbsp;&nbsp;&nbsp;
					<Link to = {{pathname:"https://edit.yahoo.com/registration?.intl=ca&amp;new=1&amp;.done=http%3A//mail.yahoo.com&amp;.src=ym&amp;.v=0&amp;.u=6fekfa147akmv&amp;partner=&amp;.partner=&amp;pkg=&amp;stepid=&amp;.p=&amp;promo=&amp;.last="}} target="_blank"><img src={Yahoomail} width="198" height="41" alt="Yahoo mail" style={{backgroundColor:"white",border:0}}/></Link><br/>
					<h1 style={{color:"blue"}}>Online Banking services</h1>
					<h4 style={{color:"grey"}}>Sign up here for your online banking services</h4>										
					<Link to = {{pathname:"https://www1.royalbank.com/cgi-bin/rbaccess/rbcgi3m01?F6=1&F7=IB&F21=IB&F22=IB&REQUEST=ClientSignin&LANGUAGE=ENGLISH&_ga=2.105464580.626690783.1631897010-503725685.1631897010"}} target="_blank"><img src={RBCLogo} width="192" height="35" alt="TD Canada Trust" style={{backgroundColor:"white",border:0}}/></Link>&nbsp;&nbsp;&nbsp;&nbsp;
					<Link to = {{pathname:"https://authentication.td.com/uap-ui/?consumer=easyweb&locale=en_CA#/uap/login"}} target="_blank"><img src={TDLogo} width="192" height="35" alt="TD Canada Trust" style={{backgroundColor:"white",border:0}}/></Link>&nbsp;&nbsp;&nbsp;&nbsp;
					<Link to = {{pathname:"http://www4.bmo.com/personal/0,4344,35649_37018,00.html"}} target="_blank"><img src={BMOLogo} width="200" height="29" alt="BMO Bank of Montreal" style={{backgroundColor:"white",border:0}} /></Link>&nbsp;&nbsp;&nbsp;&nbsp;
					<Link to = {{pathname:"https://www.scotiabank.com/ca/en/personal.html"}} target="_blank"><img src={ScotiaLogo} width="180" height="33" alt="Scotiabank" style={{backgroundColor:"white",border:0}}/></Link>&nbsp;&nbsp;&nbsp;&nbsp;
					<Link to = {{pathname:"https://www.cibconline.cibc.com/olbtxn/authentication/RegistrationLanding.cibc"}} target="_blank"><img src={CIBCLog} width="65" height="59" alt="CIBC" style={{backgroundColor:"white",border:0}}/></Link>&nbsp;&nbsp;&nbsp;&nbsp;


					<h2 style={{color:"blue"}}>Other Useful Sites</h2>					
					<Link to = {{pathname:"http://get.adobe.com/reader/"}} target="_blank"><img src={AdobeLogo} width="184" height="47" alt="ADOBE READER Logo" style={{backgroundColor:"white",border:0}}/></Link>&nbsp;&nbsp;&nbsp;&nbsp;
					<Link to = {{pathname:"http://www.cpla-acps.ca/english/home.php"}} target="_blank"><img src={HeadLogo} width="192" height="47" alt="Canadian Payday Loan Association" style={{backgroundColor:"white",border:0}}/></Link>
					
				</div>								
			</div>
		)
	}
}

export default HomtContents